import { JSX, useState, useEffect } from 'react';
import { Footer } from '@iframe-shell/components/Footer/Footer';
import { InitialPageSkeleton } from '@bg-components/Skeleton';
import { FeimFreeze } from '@iframe-shell/components/FeimFreeze';
import { appKernel } from '@iframe-shell/infrastructure/AppKernel.service';
import { useErrorHandling } from '@bg-components/ErrorBoundary/ErrorBoundaryContext';
import { RotateRestriction } from '@bg-components/RotateRestriction';
import {
    GamesContexts,
    Betting,
    SelectedBettingOptionsContext,
    AddRandomFunctionProvider,
    ModalsManager,
    ModalsManagerProvider,
} from '@bg-shared';
import { App } from './App';
import './Root.scss';

const modalsManager = new ModalsManager();

export const Root = (): JSX.Element => {
    const triggerError = useErrorHandling();
    const [pending, setPending] = useState<boolean>(true);

    useEffect(() => {
        appKernel
            .configure()
            .then(() => {
                setPending(false);
            })
            .catch((e) => {
                triggerError(
                    new Error(e instanceof Error ? e.message : 'error in application setup'),
                );
            });

        // Prevent double tap zoom
        document.addEventListener('dblclick', (e) => {
            e.preventDefault();
        });
    }, []);

    if (pending) {
        return <InitialPageSkeleton />;
    }

    return (
        <>
            <RotateRestriction />
            <FeimFreeze />
            <GamesContexts.Provider>
                <SelectedBettingOptionsContext.Provider>
                    <AddRandomFunctionProvider>
                        <Betting.Provider>
                            <ModalsManagerProvider manager={modalsManager}>
                                <App />
                                <Footer />
                            </ModalsManagerProvider>
                        </Betting.Provider>
                    </AddRandomFunctionProvider>
                </SelectedBettingOptionsContext.Provider>
            </GamesContexts.Provider>
        </>
    );
};
